import React from 'react';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import { makeChipClasses } from 'styles/pages/product';

type Props = {
    data: Array<label>;
};

type label = {
    code: string;
    name: string;
};

const renderChip = ({ code, name }: label) => {
    const chipClasses = makeChipClasses();

    return <Chip key={code} classes={chipClasses} size="medium" label={name} />;
};

const ChipPanel: React.FC<Props> = ({ data }) => <Box flex={0.9}>{data.map(renderChip)}</Box>;

export default ChipPanel;
